"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecialtyCode = void 0;
exports.instanceOfSpecialtyCode = instanceOfSpecialtyCode;
exports.SpecialtyCodeFromJSON = SpecialtyCodeFromJSON;
exports.SpecialtyCodeFromJSONTyped = SpecialtyCodeFromJSONTyped;
exports.SpecialtyCodeToJSON = SpecialtyCodeToJSON;
exports.SpecialtyCodeToJSONTyped = SpecialtyCodeToJSONTyped;
/**
 *
 * @export
 */
exports.SpecialtyCode = {
    CardiacCathLab: 'cardiac_cath_lab',
    CaseManagement: 'case_management',
    Clinic: 'clinic',
    EmergencyDepartment: 'emergency_department',
    Endoscopy: 'endoscopy',
    HomeHealth: 'home_health',
    Hospice: 'hospice',
    Icu: 'icu',
    IvInfusion: 'iv_infusion',
    LaborAndDelivery: 'labor_and_delivery',
    LongTermCare: 'long_term_care',
    MedicalSurgical: 'medical_surgical',
    MedicalSurgicalTelemetry: 'medical_surgical_telemetry',
    MentalHealth: 'mental_health',
    Nicu: 'nicu',
    OperatingRoom: 'operating_room',
    Pacu: 'pacu',
    Pediatric: 'pediatric',
    PediatricAcute: 'pediatric_acute',
    Picu: 'picu',
    ProgressiveCare: 'progressive_care'
};
function instanceOfSpecialtyCode(value) {
    for (const key in exports.SpecialtyCode) {
        if (Object.prototype.hasOwnProperty.call(exports.SpecialtyCode, key)) {
            if (exports.SpecialtyCode[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function SpecialtyCodeFromJSON(json) {
    return SpecialtyCodeFromJSONTyped(json, false);
}
function SpecialtyCodeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function SpecialtyCodeToJSON(value) {
    return value;
}
function SpecialtyCodeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=SpecialtyCode.js.map